// ============================================================================
// Table Columns: ColorDefinitions
// Key: colorDefinitions
// Generated file. Do not edit manually.
// ============================================================================

// #region Imports
import {
	cellRenderer,
	type EntityTableConfig,
	enumRenderer,
} from '../../entity-config-runtime/entity-table-config'
import type { ColorDefinitionDto } from '../api/backstage.schemas'
import { ColorRole } from '../api/backstage.schemas'
// #endregion

// #region Entity List Columns
export const colorDefinitionsListColumnsConfig = {
	columns: [
		enumRenderer('name', ColorRole, 'ColorRole'),
		cellRenderer('hexValue', 'color'),
		'modifiedBy',
		cellRenderer('modifiedUtc', 'dateTime'),
	],
	actions: [
		{
			type: 'link',
			id: 'id',
			label: 'tables_actions_detail',
			icon: 'ArrowRight',
			style: 'link',
			href: (row: ColorDefinitionDto) => `/colorDefinitions/${row.id}/details`,
		},
	],
} as const satisfies EntityTableConfig<ColorDefinitionDto>
// #endregion

// #region Columns Config Export
export const colorDefinitionsColumnsConfig = {
	list: colorDefinitionsListColumnsConfig,
} as const
// #endregion
